module.exports = __webpack_public_path__ + "biologic-black-text.png";